// extracted by mini-css-extract-plugin
export default {"paymentResponseContainer":"OrderResponse_paymentResponseContainer__PsNyr","spinner":"OrderResponse_spinner__66vHc"};